import { FC } from 'react';

export const PartnerEVStore: FC = () => {
  return <section>EV Store</section>;
};
